import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import * as sv from '@/assets/locales/sv'

export const resources = {
  sv: sv,
} as const

i18n.use(initReactI18next).init({
  resources,
  lng: 'sv',
  ns: Object.keys(sv),
  fallbackLng: 'sv',
  interpolation: {
    // react already safes from xss
    escapeValue: false,
  },
})

export default i18n
